/**
 * Service: entityApi
 */
angular.module('acme.common.service.entityApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('EntityApiService', [ '$http','QueryStringBuilderFactory', 'ApiVersionFactory', function($http, QueryStringBuilderFactory, ApiVersionFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint;
        this.schedules.service = this.service + '/entity/schedules';
        return this;
      },


      /**
       * Return a specific entity
       *
       * Accepts:
       * {
       *   type: {String} [ Personnel | Equipment | Facility ]
       *   id: {Number}
       * }
       * @param props
       * @returns {*}
       */
      detail: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/' + props.type + '/' + props.id, version: 'v2' })
        });
      },

      /**
       * Update a specific entity
       *
       * Accepts:
       * {
       *   type: {String} [ Personnel | Equipment | Facility ]
       *   id: {Number}
       * }
       * @param props
       * @returns {*}
       */
      update: function(props) {
        var av = new ApiVersionFactory(),
            data = {
              id: props.id,
              name: props.name,
              description: props.description
            };

        if (props.type === 'personnel') {
          data = {
            id: props.id,
            tenantId: props.tenantId,
            active: props.active,
            status: props.status,
            confirmed: props.confirmed,
            onBoarded: props.onBoarded,
            firstName: props.firstName,
            lastName: props.lastName,
            phoneNumber: props.phoneNumber,
            title: props.title,
            departmentId: props.departmentId,
            streetAddress1: props.streetAddress1,
            streetAddress2: props.streetAddress2,
            country: props.country,
            state: props.state,
            city: props.city,
            zipCode: props.zipCode,
            email: props.email,
            roles: props.roles
          };
        }else if (props.type === 'facilities') {
          data.capacity = props.capacity;
        }

        if (props.type === 'equipment' || props.type === 'facilities') {

          if (props.contactId) {
            data.contactId = props.contactId;
          }

          if (props.contactName) {
            data.contactName = props.contactName;
          }

          if (props.contactEmail) {
            data.contactEmail = props.contactEmail;
          }
          if (props.contactPhoneNumber) {
            data.contactPhoneNumber = props.contactPhoneNumber;
          }

        }

        if (props.profileImage) {
          data.profileImage = props.profileImage;
        }

        if (props.image) {
          data.image = props.image;
        }

        return $http({
          method: 'put',
          url: av.init({ url: this.service + '/' + props.type + '/' + props.id, version: 'v2' }),
          data: data
        });

      },

      /**
       * List all entities of a types
       *
       * @param props
       * @returns {*}
       */
      list: function(props) {

        var q = '',
            av = new ApiVersionFactory();

        if(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              paths: [ 'type' ],
              optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search', 'resourceCategoryIds']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + q, version: 'v2' })
        });

      },

      /**
       * Create a new entity
       *
       * @param props
       * @returns {*}
       */
      create: function(props) {
        var type = props.type,
            data = props;

        data.type = null;
        delete data.type;

        return $http({
          method: 'post',
          url: this.service + '/' + type,
          data: data
        });
      },


      /**
       * Removes an entity
       *
       * Accepts:
       *
       * {
       *   type: {String} [ Personnel | Equipment | Facility ]
       *   id: {Number}
       * }
       * @param props
       * @returns {*}
       */
      remove: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({ url: this.service + '/' + props.type + '/' + props.id, version: 'v2' })
        });
      },

      /**
       * Converts an existing entity to an instance
       *
       * @param props
       * @returns {*}
       */
      convert: function(props) {
        return $http({
          method: 'post',
          url: this.service + '/' + props.type + '/convert/' + props.id
        });
      },

      schedules: {

        service: '',

        /**
         * Returns an entity schedule based on an instance id
         *
         * @param id
         * @returns {*}
         */
        event: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/event/' + id
          });
        },

        updateEvent: function(props) {
          return $http({
            method: 'put',
            url: this.service + '/event/' + props.id,
            data: props
          });
        },

        rsvp: function(props) {
          return $http({
            method: 'post',
            url: this.service + '/rsvp',
            data: {
              id: props.id,
              rsvpState: props.rsvpState
            }
          });
        },

        resource: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/resource/' + id
          });
        },

        owner: function(props) {
          var q = '',
            query = [];

          if (props.endTime) {
            query.push('endTime=' + props.endTime);
          }

          if (props.startTime) {
            query.push('startTime=' + props.startTime);
          }

          if (query.length > 0) {
            q = '?' + query.join('&');
          }

          return $http({
            method: 'get',
            url: this.service + '/owner/' + props.ownerId + q
          });
        }


      }
    };

}]);